export default __webpack_public_path__ + "static/media/Jost-ExtraLight.343dac28.ttf";